import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import styles from "./TBody.module.scss";
import {useNavigate} from "react-router-dom";
import {getDateFromISOString} from "../../utils/getAge";
import {TranslatorValues} from "../../const/TranslatorValues";
import {useDispatch, useSelector} from "react-redux";
import { editContract, hideContract, showContract, showPopup } from "../../store/reducers/ContractReducer/ContractReducer";
import { toast } from "react-toastify";

export const TBody = ({
    paginatedInfo,
    navigateUrl,
    setAction,
    handleUrl,
    activeRead = true,
    activeEdit = true,
    activeAdditional = true
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const role = useSelector(state=>state.login.userInfo.permissions.contracts_manage)

    
    const handleEdit = (id) => {
        if(role){
            dispatch(editContract({credential: id}))
            navigate('/EditContract')
        } else {
            toast.error('В доступі відмовлено!')
        }
    };

    const handleFullInfo = (id) => {
        dispatch(showContract({credential: id}))
    };

    const handleAdd = (id) => {
        dispatch(hideContract())
        dispatch(showPopup({credential: id}))
    }


    return (
        <tbody className={styles['pagination__body']}>
        {paginatedInfo?.map((item, index) => (
            <tr key={item.id || index} className={index % 2 == 0 ? 'even-row' : 'odd-row'}>
                {Object.keys(item).map((key, idx) => (
                    <th key={idx}>
                        <div className="th-text-ellipsis">
                            {item[key] !== null && item[key] !== undefined && item[key] !== '' ?
                                ['birthDate', 'createdAt', 'updatedAt', 'operationDate'].includes(key) ? getDateFromISOString(item[key].toString())
                                    : ['role', 'status', 'outside'].includes(key) ? TranslatorValues(item[key].toString()) : item[key].toString()
                                : '---'}
                        </div>
                    </th>
                ))}
                {(activeRead  || activeEdit) && <th className={styles.tableSettings}>
                    {activeRead && <div onClick={() => handleFullInfo(item.id)}><ImportContactsIcon/></div>}
                    {activeEdit && <div onClick={() => handleEdit(item.id)}><CreateIcon/></div>}
                    {activeAdditional && <div onClick={() => handleAdd(item.id)}><AddIcon/></div>}
                </th>}
            </tr>
        ))}
        </tbody>
    );
};